import React from "react";
import Routes from "./Routes";
import ReactDOM from "react-dom/client";

import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
function App() {
  return (
    <Routes />
  );
}

export default App;
